export enum BookPastDueBehaviour {
  DEFAULT = "DEFAULT",
  ALLOW = "ALLOW",
  DENY = "DENY"
}
